import { Dispatch } from 'redux';
import {NewsPostData, NewsPostHeaderData} from "../Data Types/NewsPostData";
// import {fetchNewsPostsFromURI} from "../Services/NewsPostDataService";
import {RootState} from "./reducers";

export const SET_NEWS_POSTS = "SET_NEWS_POSTS";
export const SET_SELECTED_POST_ID = "SET_SELECTED_POST_ID";
export const SET_SELECTED_POST = "SET_SELECTED_POST";
export const SET_NEWS_LOADING = "SET_NEWS_LOADING";
export const SET_NEWS_ERROR = "SET_NEWS_ERROR";
export const CLEAR_NEWS_ERROR = "CLEAR_NEWS_ERROR";

export interface SetNewsPostsAction {
    type: string;
    payload: NewsPostHeaderData[];
}

export interface SetSelectedPostIdAction {
    type: string;
    payload: string | null;
}

export interface SetSelectedPostAction {
    type: string;
    payload: NewsPostData | null;
}

export interface SelectNewsPostsAction {
    type: string;
}

// TODO: Does this need a post ID? This seems to work regardless.
export interface SelectNewsPostAction {
    type: string;
}

export interface SetNewsLoadingAction {
    type: string;
    payload: boolean;
}

export interface SetNewsErrorAction {
    type: string;
    payload: string;
}

export interface ClearNewsErrorAction {
    type: string;
}

export const setNewsPosts = (headers: NewsPostHeaderData[]) => ({
    type: SET_NEWS_POSTS,
    payload: headers,
});

export const setSelectedPostId = (postId: string | null) => ({
    type: SET_SELECTED_POST_ID,
    payload: postId,
});

export const setSelectedPost = (post: NewsPostData | null) => ({
    type: SET_SELECTED_POST,
    payload: post,
});

export const setNewsLoading = (loading: boolean) => ({
    type: SET_NEWS_LOADING,
    payload: loading,
});

export const setNewsError = (error: string) => ({
    type: SET_NEWS_ERROR,
    payload: error,
});

export const clearNewsError = () => ({
    type: CLEAR_NEWS_ERROR,
});

// Async actions

//  After the return statement, set the state to "LOADING".
//  Perhaps show a loading icon or something. Same forall async actions.
export const selectNewsPosts = (useApi: boolean) => {
    return async (dispatch: Dispatch<ActionTypes>) => {
        try {
            dispatch(clearNewsError());
            dispatch(setNewsLoading(true));
            
            const fetchUrl = useApi ?
                    'https://0lcvhovr0f.execute-api.us-east-1.amazonaws.com/default/BlawnodeCom/NewsDatabaseReader'
                    : "/Static Test Datas/coalesced_newsposts_public.json";
            
            const response = await fetch(fetchUrl);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data: NewsPostHeaderData[] = await response.json();
            
            if (!Array.isArray(data)) {
                throw new Error('Invalid data format received from server');
            }
            
            // console.log("FETCHED ALL POSTS FROM DYNAMO");
            dispatch(setNewsPosts(data));
        }
        catch (error) {
            let errorMessage = 'An unexpected error occurred';
            
            if (error instanceof Error) {
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }
            
            console.error('Error fetching news posts:', error);
            dispatch(setNewsError(`Failed to fetch news posts: ${errorMessage}`));
        }
    };
};

export const selectNewsPost = (postId: string) => {
    return async (dispatch: Dispatch<ActionTypes>, getState: () => RootState) => {
        try {
            // Clear any previous errors
            dispatch(clearNewsError());
            
            // const newsPostDatas: NewsPostData[] = await fetchNewsPosts(useApi);
            //const response = await fetch(`/api/news-posts/${postId}`);
            //const data: NewsPostData = await response.json();
            const newsPostDatas = getState().newsPostDatas;
            let data: NewsPostData | undefined = undefined;
            data = newsPostDatas.find((x: NewsPostData) => x.id === postId);
            
            if (data) {
                // console.log(`FETCHED POST '${postId}': ${JSON.stringify(data)}`);
                dispatch(setSelectedPost(data));
            } else {
                // console.log(`COULDN'T FETCH THE POST '${postId}'`);
                dispatch(setNewsError(`News post with ID '${postId}' not found`));
                dispatch(setSelectedPost(null));
            }
        } catch (error) {
            let errorMessage = 'An unexpected error occurred while selecting the news post';
            
            if (error instanceof Error) {
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }
            
            console.error('Error selecting news post:', error);
            dispatch(setNewsError(errorMessage));
            dispatch(setSelectedPost(null));
        }
    };
};

export type ActionTypes =
    | SetNewsPostsAction
    | SetSelectedPostIdAction
    | SetSelectedPostAction
    | SelectNewsPostsAction
    | SelectNewsPostAction
    | SetNewsLoadingAction
    | SetNewsErrorAction
    | ClearNewsErrorAction
;